import Vue from 'vue'
import moment from 'moment'

const Filters = {
	date(value) {
		return value ? moment(value).format('DD.MM.YYYY') : ''
	},
	dateAndTime(value) {
		return value ? moment(value).format('DD.MM.YYYY - HH:mm') : ''
	},
	time(value) {
		return value ? moment(value).format('HH:mm') : ''
	},
	euro(value) {
		const rounded = (Math.round(value * 100) / 100 || 0).toFixed(2)
		const formated = rounded
			.toString()
			.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
			.replace(/\.(?=(\d\d$))/, ',')
		return formated + ' €'
	}
}

Vue.filter('date', Filters.date)
Vue.filter('dateAndTime', Filters.dateAndTime)
Vue.filter('time', Filters.time)
Vue.filter('euro', Filters.euro)

export default Filters
